<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-overlay
        variant="white"
        :show="loading"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
      ></b-overlay>
      <b-card class="mb-0">

        <!-- logo -->
        <b-link class="brand-logo">
          <vuexy-logo />

          <h2 class="brand-text text-primary ml-1">
            МИГ
          </h2>
        </b-link>

        <b-card-title class="mb-1">
          Сменить пароль
        </b-card-title>
        <b-card-text class="mb-2">
          Новый пароль должен отличаться от прошлого
        </b-card-text>

        <!-- form -->
        <validation-observer
                ref="form"
                #default="{invalid}"
        >
          <b-form
            class="auth-reset-password-form mt-2"
            @submit.prevent="resetPassword"
          >

            <!-- password -->
            <b-form-group
              label="Новый пароль"
              label-for="reset-password-new"
            >
              <validation-provider
                #default="{ errors }"
                name="password"
                vid="password"
                rules="required|password"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="reset-password-new"
                    v-model="password"
                    :type="passwordFieldType"
                    :state="errors.length > 0 ? false:null"
                    class="form-control-merge"
                    name="reset-password-new"
                    placeholder="············"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                        class="cursor-pointer"
                        :icon="passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'"
                        @click="() => passwordFieldType = passwordFieldType === 'password' ? 'text' : 'password'"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- confirm password -->
            <b-form-group
              label-for="reset-password-confirm"
              label="Подтвердите пароль"
            >
              <validation-provider
                #default="{ errors }"
                name="password_confirm"
                rules="required|confirmed:password"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="reset-password-confirm"
                    v-model="password_confirm"
                    :type="passwordConfirmFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false:null"
                    name="reset-password-confirm"
                    placeholder="············"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                            class="cursor-pointer"
                            :icon="passwordConfirmFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'"
                            @click="() => passwordConfirmFieldType = passwordConfirmFieldType === 'password' ? 'text' : 'password'"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
              block
              type="submit"
              variant="primary"
              :disabled="invalid"
            >
              Установить новый пароль
            </b-button>
          </b-form>
        </validation-observer>

        <p class="text-center mt-2">
          <b-link :to="{name:'auth-login-v1'}">
            <feather-icon icon="ChevronLeftIcon" /> Назад ко входу
          </b-link>
        </p>
      </b-card>
    </div>
  </div>
</template>

<script>
  import VuexyLogo from '@core/layouts/components/Logo.vue'

  import {
    BOverlay,
    BCard, BCardTitle, BCardText,
    BForm, BFormGroup,
    BInputGroup, BFormInput, BInputGroupAppend,
    BLink, BButton,
  } from 'bootstrap-vue'

  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { required } from '@validations'

  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

  import useAuthentication from './useAuthentication'



export default {
  components: {
    VuexyLogo,
    BCard,
    BButton,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BInputGroup,
    BLink,
    BFormInput,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BOverlay
  },

  setup () {
    const {
      form,
      password,
      password_confirm,
      loading,
      resetPassword,
      passwordFieldType,
      passwordConfirmFieldType
    } = useAuthentication()

    return {
      form,
      password,
      password_confirm,
      loading,
      resetPassword,
      passwordFieldType,
      passwordConfirmFieldType
    }
  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
